<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h4>Cancel Purchase Order - Confirmation</h4>
      <Notification :notify="notify" />
      <!--Are you sure, do you want to return on going borrowed publications, if available ?-->
      <div class="pl-10 pr-10 pb-10 pt-10">
        <v-alert outlined color="error">
          <div class="row">
            <div class="col">
              <div class="pt-10">
                <v-checkbox
                  v-model="returnBorrowedPublications"
                  label="All ongoing borrowed publications will be returned. Are you sure that this purchase order should be cancelled?"
                  color="red"
                  value="red"
                  hide-details
                ></v-checkbox>
              </div>
            </div>
          </div>
          <!--
          <div class="row">
            <div class="col">
              <div>
                <v-checkbox
                  v-model="cancelPurchaseOrder"
                  label="Are you sure, do you want to cancel purchase order?"
                  color="red"
                  value="red"
                  hide-details
                ></v-checkbox>
              </div>
            </div>
          </div>
          -->
          <div class="row">
            <div class="col">
              <div class="float-left"></div>
              <div class="float-right">
                <ConfirmationDialog ref="confirm" />
                <v-btn depressed color="error" @click="onCancel()">
                  Cancel Purchase Order
                </v-btn>
              </div>
            </div>
          </div>
        </v-alert>
      </div>
    </v-card>
  </div>
</template>
<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";

export default {
  name: "CancelPurchaseOrderLendingConfirmation",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
  },
  props: {
    /* organizationId: { type: Number, required: true} */
  },
  watch: {},
  created() {},
  methods: {
    async onCancel() {
      console.log('onCancel')
      this.notify.errors.splice(0, this.notify.errors.length);
      this.notify.type = 4;
      if (
        this.returnBorrowedPublications == false
        //||  this.cancelPurchaseOrder == false
      ) {
        this.notify.errors.push(
          "Please agree with the bellow statement in order to cancel this purchase order."
        );
        return true;
      }

      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to cancel this purchase order?"
        )
      ) {
        // Return publications
        this.cancelLending();
        //this.cancelPurchaseOrder();
      }
    },
    cancelOP() {
      console.log('cancelPurchaseOrder')
      new Promise((resolve, reject) => {
        api
          .DeleteByID("purchase-order/cancel", this.$route.params.id)
          .then((response) => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.notify.message = "Purchase order successfully canceled";
              setTimeout(() => {
                this.notify.type = 0;
                if (this.$route.params.iscollection)
                  window.location = `/fulfillmentcollections`;
                else window.location = `/purchase`;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
            }
          })
          .catch((error) => {
            this.notify.type = 4;
            this.notify.errors.push("Failed to save data. " + error);
            reject(error);
          });
      });
    },
    cancelLending() {
      console.log('cancelLending')
      new Promise((resolve, reject) => {
        api
          .update("lending/cancel/" + this.$route.params.id, {"id":0})
          .then((response) => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.cancelOP();
            }
          })
          .catch((error) => {});
      });
    },
  },
  data() {
    return {
      Search: "",
      item: {},
      list: [],
      details: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      paging: { count: 10, page: 1, size: 10, keyword: "", isASC: false },
      returnBorrowedPublications: false,
      cancelPurchaseOrder: false,
    };
  },
};
</script>
<style scoped>
.danger {
  background-color: #ffcdd2;
}
</style>


// WEBPACK FOOTER //
// src/components/PO-Cancellation/CancelPurchaseOrderLendingConfirmation.vue